import * as S from "./styles";
import {Col, Row} from "../../../styles/components";
import {FormattedMessage} from "react-intl";
import {useStores} from "../../../hooks/useStores";
import {ReactComponent as TwitterIcon} from "../../../assets/icons/social/tv.svg";
import {ReactComponent as FacebookIcon} from "../../../assets/icons/social/fb.svg";
import {ReactComponent as InstagramIcon} from "../../../assets/icons/social/inst.svg";
import {ReactComponent as VKIcon} from "../../../assets/icons/social/vk.svg";
import {ReactComponent as LinkedInIcon} from "../../../assets/icons/social/in.svg";
import {ReactComponent as TwitterIconDark} from "../../../assets/icons/social/tv_d.svg";
import {ReactComponent as FacebookIconDark} from "../../../assets/icons/social/fb_d.svg";
import {ReactComponent as InstagramIconDark} from "../../../assets/icons/social/inst_d.svg";
import {ReactComponent as VKIconDark} from "../../../assets/icons/social/vk_d.svg";
import {ReactComponent as LinkedInIconDark} from "../../../assets/icons/social/in_d.svg";

export const Footer = () => {
    const { uiStore } = useStores();

    const Social = uiStore.isLightTheme
        ?
        <S.Social>
            <S.SocialLink to={'/'}><TwitterIcon/></S.SocialLink>
            <S.SocialLink to={'/'}><FacebookIcon/></S.SocialLink>
            <S.SocialLink to={'/'}><InstagramIcon/></S.SocialLink>
            <S.SocialLink to={'/'}><VKIcon/></S.SocialLink>
            <S.SocialLink to={'/'}><LinkedInIcon/></S.SocialLink>
        </S.Social>
        :
        <S.Social>
            <S.SocialLink to={'/'}><TwitterIconDark/></S.SocialLink>
            <S.SocialLink to={'/'}><FacebookIconDark/></S.SocialLink>
            <S.SocialLink to={'/'}><InstagramIconDark/></S.SocialLink>
            <S.SocialLink to={'/'}><VKIconDark/></S.SocialLink>
            <S.SocialLink to={'/'}><LinkedInIconDark/></S.SocialLink>
        </S.Social>

    return (
        <S.Footer>
            <S.Container>
                <Row>
                    <Col xl={8} lg={8} xs={8}>
                        <S.Brand>TeleGuard</S.Brand> <S.BrandDesc><FormattedMessage id='footerTitle'/></S.BrandDesc>
                    </Col>
                    <Col xl={4} lg={4} xs={4}>
                        {Social}
                    </Col>
                </Row>
                <br/>
                <S.Line>
                    <S.Links>
                        <span><S.Link to={"/"}><FormattedMessage id='footerQuestion'/></S.Link></span>
                        <span><S.Link to={"/"}><FormattedMessage id='footerTerms'/></S.Link></span>
                        <span><S.Link to={"/impression"}><FormattedMessage id='footerImpression'/></S.Link></span>
                        <span><S.Link to={"/"}><FormattedMessage id='footerBetaTest'/></S.Link></span>
                        <span><S.Link to={"/"}><FormattedMessage id='footerConfidentiality'/></S.Link></span>
                        <span><S.Link to={"/"}><FormattedMessage id='footerPress'/></S.Link></span>
                    </S.Links>
                    <S.CopyRights>©2022, Swisscows AG</S.CopyRights>
                </S.Line>
            </S.Container>
            <S.SmallContainer>
                {Social}
                <S.Link to={"/"}><FormattedMessage id='footerQuestion'/></S.Link>
                <S.Link to={"/"}><FormattedMessage id='footerBetaTest'/></S.Link>
                <S.Link to={"/"}><FormattedMessage id='footerTerms'/></S.Link>
                <S.Link to={"/"}><FormattedMessage id='footerConfidentiality'/></S.Link>
                <S.Link to={"/impression"}><FormattedMessage id='footerImpression'/></S.Link>
                <S.Link to={"/"}><FormattedMessage id='footerPress'/></S.Link>
                <S.CopyRights>©2022, Swisscows AG</S.CopyRights>
            </S.SmallContainer>
        </S.Footer>
    );
}